import type { FC } from 'react';

import Count from './Count';
import List from './List';
import styles from './styles.module.scss';

const Users: FC = () => {
    return (
        <div className={styles.wrapper}>
            <Count />
            <List />
        </div>
    );
};

export default Users;
